import './Loading.css';

const Loading = () => {
    return (
        <div class="container">
            <div class="square one"></div>
            <div class="square two"></div>
            <div class="square three"></div>
            <div class="square two"></div>
            <div class="square three"></div>
            <div class="square four"></div>
            <div class="square three"></div>
            <div class="square four"></div>
            <div class="square five"></div>
        </div>
    );
}

export default Loading;